import { render } from "./CustomerEditBasic.vue?vue&type=template&id=62fff854&scoped=true"
import script from "./CustomerEditBasic.vue?vue&type=script&lang=js"
export * from "./CustomerEditBasic.vue?vue&type=script&lang=js"

import "./CustomerEditBasic.vue?vue&type=style&index=0&id=62fff854&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fff854"]])

export default __exports__